
import Navigation from '../../components/feature/Navigation';
import SharedForm from '../../components/SharedForm';
import contactHero from '../../assets/elite pics/WhatsApp Image 2026-01-27 at 9.58.35 AM.jpeg?url';

const Contact = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <Navigation />

      {/* Hero Section */}
      <div
        className="py-24 pt-44 relative overflow-hidden bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 90, 44, 0.6), rgba(0, 90, 44, 0.6)), url('${contactHero}')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">Contact Us</h1>
          <p className="text-xl text-green-100 max-w-3xl mx-auto">
            Get in touch with Elite College. We're here to answer your questions and help
            you start your educational journey.
          </p>
        </div>
      </div>

      {/* Contact Content */}
      <div className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Information */}
            <div>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#1B5E20] rounded-full flex items-center justify-center">
                    <i className="ri-map-pin-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">Address</h3>
                    <p className="text-gray-600">535 Mataga</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#1B5E20] rounded-full flex items-center justify-center">
                    <i className="ri-phone-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">Phone</h3>
                    <p className="text-gray-600">
                      +263 774 872 973<br />
                      +263 719 872 973
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#1B5E20] rounded-full flex items-center justify-center">
                    <i className="ri-mail-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">Email</h3>
                    <p className="text-gray-600">info@elitecollege.co.zw</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#1B5E20] rounded-full flex items-center justify-center">
                    <i className="ri-time-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">Office Hours</h3>
                    <p className="text-gray-600">
                      Monday - Friday: 8:00 AM - 6:00 PM<br />
                      Saturday: 9:00 AM - 4:00 PM<br />
                      Sunday: Closed
                    </p>
                  </div>
                </div>
              </div>

              {/* Map */}
              <div className="mt-8">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Find Us</h3>
                <div className="bg-gray-200 rounded-lg overflow-hidden">
                  <iframe
                    src="https://maps.google.com/maps?q=-20.841225,30.185128&z=16&output=embed"
                    width="100%"
                    height="300"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>

            {/* Contact Form: use shared form that sends the full message as `message` */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Send us a Message</h2>
              <SharedForm formType="contact" />
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-[#1B5E20] text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <img
                  src="https://static.readdy.ai/image/e999ec2dea4e4b618de520757ef9db5d/995999b745e34f0ed4248820e32af9bb.jpeg"
                  alt="Elite College Logo"
                  className="w-10 h-10 rounded-full object-cover"
                />
                <span className="text-xl font-bold">Elite College</span>
              </div>
              <p className="text-green-100">
                Empowering minds, shaping futures through excellence in education.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2">
                <li>
                  <a href="/" className="text-green-100 hover:text-[#C6A44C] cursor-pointer">
                    Home
                  </a>
                </li>
                <li>
                  <a href="/about" className="text-green-100 hover:text-[#C6A44C] cursor-pointer">
                    About
                  </a>
                </li>
                <li>
                  <a href="/admissions" className="text-green-100 hover:text-[#C6A44C] cursor-pointer">
                    Admissions
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Student Resources</h3>
              <ul className="space-y-2">
                <li>
                  <a href="/gallery" className="text-green-100 hover:text-[#C6A44C] cursor-pointer">
                    Gallery
                  </a>
                </li>
                <li>
                  <a href="/contact" className="text-green-100 hover:text-[#C6A44C] cursor-pointer">
                    Contact Us
                  </a>
                </li>
                <li>
                  <a href="#" className="text-green-100 hover:text-[#C6A44C] cursor-pointer">
                    Library
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
              <ul className="space-y-2 text-gray-300">
                <li className="flex items-center">
                  <i className="ri-map-pin-line mr-2 text-[#C6A44C]"></i>
                  535 Mataga
                </li>
                <li className="flex items-center">
                  <i className="ri-phone-line mr-2 text-[#C6A44C]"></i>
                  +263 774 872 973
                </li>
                <li className="flex items-center">
                  <i className="ri-mail-line mr-2 text-[#C6A44C]"></i>
                  info@elitecollege.co.zw
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-[#007A3D] mt-8 pt-8 text-center text-gray-300">
            <p>&copy; 2026 Elite College. All rights reserved.</p>
            <p className="mt-2 text-sm">
              Powered by{' '}
              <a
                href="https://onhightech.co.zw"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#C6A44C] hover:text-white underline cursor-pointer transition-colors"
              >
                Onhightech Solutions
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Contact;
